<template>
  <el-container class="application-wrapper" direction="vertical">
    <el-main class="application-print-template">
      <div style="clear:both">
        <table style="width:486.15pt; margin-right:9pt; margin-left:9pt; border-collapse:collapse; float:left">
          <tr style="height:1.2pt">
            <td style="width:484.65pt; padding:0.75pt; vertical-align:middle">
              <p style="text-align:right; widows:0; orphans:0">
                <span style="font-size:10pt; color:#808080">Приложение 2</span><br/><span
                  style="font-size:10pt; color:#808080">к стандарту государственной услуги </span>
              </p>
              <p style="text-align:right; widows:0; orphans:0; font-size:10pt">
                <span style="color:#808080">"Предоставление общежития обучающимся в высших учебных заведениях"</span>
              </p>
            </td>
          </tr>
        </table>
        <p class="Header">
          &#xa0;
        </p>
      </div>
      <p style="margin-left:212.65pt">
        &#xa0;
      </p>
      <p style="margin-left:212.65pt">
        <span style="height:0pt; display:block; position:absolute; z-index:0"><img
            src="./assets/1724495749_application-1.png" width="143" height="133"
            alt="qr code"
            style="margin-top:7.4pt; margin-left:-204.7pt; position:absolute"/></span>
        <span style="display: inline-block">Ректору&#xa0; ТОО «Казахстанско-Американского свободного университета» доктору философии (PhD)</span>
      </p>
      <p style="margin-left:226.8pt">
        <strong>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </strong><strong>Мамбетказиеву Айдару Ережеповичу</strong>&#xa0;&#xa0;&#xa0;
      </p>
      <p style="margin-left:226.8pt; line-height:115%">
        &#xa0;
      </p>
      <p style="margin-left:226.8pt; text-align:center; line-height:115%">
        <!--      От&#xa0; обучающегося&#xa0; {{ study_place }}-->
        От&#xa0; обучающегося&#xa0; {{ application.study_place.name_ru }}
        <!--      <el-select v-model="changes.study_place" placeholder="Select" size="mini">
                <el-option
                  size="mini"
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>-->
      </p>
      <p style="margin-left:226.8pt; text-align:center; line-height:115%">
        <!--      {{ payment_method }}-->
        {{ application.payment_method.name_ru }}
        <!--      <el-select v-model="changes.payment_method" placeholder="Select" size="mini">
                <el-option
                  size="mini"
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>-->
      </p>
      <p style="margin-left:226.8pt; text-align:center; line-height:115%">
        <strong>&#xa0;</strong>
      </p>
      <p style="margin-left:226.8pt; text-align:center; line-height:115%; font-size:16pt">
        <!--      <strong>&#xa0;</strong><strong>{{ applicant_name }}</strong>-->
        <el-input placeholder="Имя заявителя" v-model="changes.applicant_name" />
      </p>
      <p style="margin-left:226.8pt; text-align:center; line-height:115%; font-size:11pt">
        ФИО обучающегося
      </p>
      <p style="margin-left:226.8pt; text-align:justify; line-height:115%; font-size:16pt">
        <strong>&#xa0;</strong>
      </p>
      <p style="text-align:center; font-size:16pt">
        <strong>З А Я В Л Е Н И Е</strong>
      </p>
      <p style="text-align:center; font-size:16pt">
        <strong>&#xa0;</strong>
      </p>
      <p style="text-align:justify; line-height:150%; font-size:16pt">
      <span
          style="line-height:150%; font-size:14pt">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
          style="line-height:150%; font-size:14pt">Прошу Вас выделить мне одно место в общежитии университета по проспекту Шакарима 160</span><span
          style="line-height:150%; font-size:14pt">&#xa0; </span><span
          style="line-height:150%; font-size:14pt">c </span><strong>
        <el-input placeholder="Дата" v-model="changes.date" />
      </strong><strong><em><span
          style="line-height:150%; font-size:14pt; ">. </span></em></strong>
      </p>
      <p class="BodyTextIndent" style="text-indent:0pt; text-align:left; line-height:150%">
        Место прописки: &#xa0; <span style="color:#212529; background-color:#ffffff">
        <el-input placeholder="Адрес" v-model="changes.address" style="width: 500px;"/></span>
      </p>
      <p class="BodyTextIndent" style="text-indent:0pt; text-align:right; line-height:150%">
        <span style="color:#bfbfbf">Подпись</span>_______________
      </p>
      <p style="text-align:right">
        &#xa0;<span style="color:#a6a6a6"> </span><span style="color:#bfbfbf">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>
      </p>
      <p class="NormalWeb">
        <span class="apple-style-span" style="font-weight:bold">Согласовано:</span><br/>Первый Вице-Президент –Байкенов
        Жасулан Ерболович
      </p>
      <p class="NormalWeb">
        Проректор - Кикина Марина Ивановна
      </p>
      <p class="NormalWeb">
        <span class="apple-style-span" style="font-weight:bold">Согласовано:</span><br/>
        Главный бухгалтер -
<!--        Беседа Любовь Александровна-->
        <el-input placeholder="Имя бухгалтера" v-model="changes.accountant_name"/>
        <br/><span class="apple-style-span" style="font-weight:bold">&#xa0;</span>
      </p>
      <p class="NormalWeb">
        <span class="apple-style-span" style="font-weight:bold">Вх. №</span><span class="apple-style-span"
                                                                                  style="font-weight:bold">&#xa0;</span>ЦОС-<strong>____/_____</strong>&#xa0;&#xa0;&#xa0;
        &#xa0;<span class="apple-style-span" style="font-weight:bold">от</span>&#xa0;«____»&#xa0; _____________20____ г.
      </p>
      <p class="NormalWeb">
        <img src="./assets/1724495749_application-2.png" width="646" height="1" alt=""/>
      </p>
      <p style="font-size:8pt">
        <em>&#xa0;</em>
      </p>
      <table style="width:475.65pt; margin-right:9pt; margin-left:9pt; border-collapse:collapse; float:left">
        <tr style="height:1.5pt">
          <td style="width:133.95pt; padding:0.75pt; vertical-align:middle">
            <p style="text-align:justify; line-height:115%; widows:0; orphans:0; font-size:10pt">
              &#xa0;
            </p>
          </td>
          <td style="width:338.65pt; padding:0.75pt; vertical-align:middle">
            <p style="text-align:right; widows:0; orphans:0; font-size:9pt">
              <span style="color:#808080">&#xa0;</span>
            </p>
            <p style="text-align:right; widows:0; orphans:0; font-size:9pt">
              <span style="color:#808080">&#xa0;</span>
            </p>
            <p style="text-align:right; widows:0; orphans:0; font-size:9pt">
              <span style="color:#808080">Приложение 1</span><br/><span style="color:#808080">к стандарту государственной услуги</span>
            </p>
            <p style="text-align:right; widows:0; orphans:0; font-size:9pt">
              <span style="color:#808080">&#xa0;</span><span style="color:#808080">"Предоставление общежития обучающимся в высших учебных заведениях"</span>
            </p>
          </td>
        </tr>
      </table>
      <p style="text-align:center; line-height:115%; font-size:16pt">
        <br>
        <strong style="display: inline-block;">Направление</strong><br/><strong><span
          style="line-height:115%; font-size:14pt; ">о предоставлении места в общежитии</span></strong>
      </p>
      <p style="text-align:center; font-size:11pt">
        ТОО «Казахстанско-Американский свободный Университет»
      </p>
      <p style="text-align:center; font-size:10pt">
        ВКО г.Усть-Каменогорск ул. М.Горького,76
      </p>
      <p style="margin-left:21.3pt; text-indent:-21.3pt; font-size:16pt">
        <span style="font-size:14pt">Гражданину(-ке)</span>
        <el-input placeholder="Имя заявителя" v-model="changes.applicant_name"/>
      </p>
      <p style="line-height:150%; font-size:8pt">
        &#xa0;
      </p>
      <p style="line-height:150%; font-size:14pt">
        Направляю на заселение в общежитие КАСУ № 1
      </p>
      <p style="line-height:150%; font-size:14pt">
        Адрес общежития:&#xa0;&#xa0;
        <strong><em>г.Усть-Каменогорск, </em></strong><strong><em>&#xa0;</em></strong><strong><em>пр.Шакарима
        160</em></strong>
      </p>
      <p style="line-height:150%; font-size:14pt">
        <span style="height:0pt; display:block; position:absolute; z-index:-1">
          <img
              src="./assets/1724495749_application-3.png" width="124" height="97"
              alt="http://detrix.kafu.kz:88/modules/profile/images/image.png"
              style="margin-top:15pt; margin-left:181.2pt; position:absolute"/></span><strong>
        <!--      <em>Предлагаю Вам явиться {{ changes.date }}</em>-->
        <em>Предлагаю Вам явиться
          <el-input placeholder="Дата" v-model="changes.date"/>
        </em>
      </strong><strong><em><span style="color:#ff0000"> </span></em></strong>
      </p>
      <p style="text-indent:269.35pt">
        &#xa0;
      </p>
      <p style="text-indent:283.5pt; font-size:10pt">
        <span style="height:0pt; display:block; position:absolute; z-index:-2"><img
            src="./assets/1724495749_application-4.png" width="226" height="69" alt=""
            style="margin-top:721.5pt; margin-left:-3.1pt; position:absolute"/></span><span
          style="height:0pt; display:block; position:absolute; z-index:-3"><img
          src="./assets/1724495749_application-4.png" width="226" height="69" alt=""
          style="margin-top:721.5pt; margin-left:-3.1pt; position:absolute"/></span><span
          style="height:0pt; display:block; position:absolute; z-index:-4"><img
          src="./assets/1724495749_application-4.png" width="226" height="69" alt=""
          style="margin-top:721.5pt; margin-left:-3.1pt; position:absolute"/></span><span
          style="height:0pt; display:block; position:absolute; z-index:-5"><img
          src="./assets/1724495749_application-4.png" width="226" height="69" alt=""
          style="margin-top:721.5pt; margin-left:-3.1pt; position:absolute"/></span><strong>Выдал
        направление:</strong> Директор
      </p>
      <p style="text-indent:283.5pt; font-size:10pt">
        Центра обслуживания студентов КАСУ
      </p>
      <p style="font-size:14pt">
        <strong>Ректор: Мамбетказиев А.Е.</strong><span style="font-size:12pt">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
          style="font-size:12pt">Василенко О.Б ________________</span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;
      </p>
    </el-main>

    <el-footer>
      <button class="btn btn-primary" @click="printApplication">Скачать справку</button>

      <button class="btn btn-primary" @click="closeDetail">Закрыть</button>
    </el-footer>
  </el-container>
</template>
<script>
import dayjs from 'dayjs'
import settingsApi from '@/api/settings'
import {get_country_name, get_region_name} from '@/helpers/formatters'
import adminApi from '@/api/admin'
import applicationApi from '@/api/application'
// converted using https://wordtohtml.net/convert/docx-to-html
export default {
  props: {
    application: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      changes: {
        applicant_name: '',
        study_place: '',
        payment_method: '',
        date: '',
        address: '',
        accountant_name: ''
      }
    }
  },
  mounted() {
    this.updateChanges();

    settingsApi.getSetting('arrival_date').then((response) => {
      this.changes.date = this.$dayjs(response.data.value).tz('Asia/Almaty').locale('ru').format('D MMMM YYYY года');
    })

    settingsApi.getSetting('accountant_name').then((response) => {
      this.changes.accountant_name = response.data.value;
    })
  },
  watch: {
    application: {
      handler() {
        this.updateChanges();
      },
      deep: true
    }
  },
  methods: {
    printApplication: function () {
      let id = this.application.id

      applicationApi.downloadDocxDocument(id, {changes: this.changes}).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `заявление общежитие ${this.application.full_name}.docx`
        )
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
    },
    updateChanges() {
      let address = '';

      let country = '';
      if (this.application.country) {
        if (this.application.country.length === 3) {
          country = get_country_name(this.application.country, "ru") + ', ';
        } else {
          country = this.application.country + ', ';
        }
      }

      let region = '';
      if (this.application.region) {
        const isKazakhstan = this.application.country === 'KAZ' || this.application.country.toLowerCase().includes('казах');
        if (this.application.region.length === 2 && get_region_name(this.application.region, "ru") && isKazakhstan) {
          region = get_region_name(this.application.region, "ru") + ', ';
        } else if (this.application.region.length !== 2 && isKazakhstan) {
          region = this.application.region + ', ';
        } else {
          region = '';
        }
      }

      address += country;
      address += region;
      address += this.application.city ? `${this.application.city}, ` : '';
      address += this.application.street ? `${this.application.street}, ` : '';
      address += this.application.house ? `${this.application.house}, ` : '';
      address += this.application.flat ? `${this.application.flat}, ` : '';

      this.changes = {
        applicant_name: this.application.full_name,
        study_place: this.application.study_place?.name_ru || '',
        payment_method: this.application.payment_method?.name_ru || '',
        date: '',
        address: address,
        accountant_name: ''
      };
    },
    closeDetail() {
      this.$emit('closeDetail');
    }
  }
}
</script>
<style scoped>
@import url("./normalize.css");

.application-print-wrapper .el-footer button {
    margin-right: 20px;
}

.application-print-template {
  font-family: 'Times New Roman';
  font-size: 12pt;
  width: 725px;
  margin: 0 auto;
}

.application-print-template {
  word-break: initial;
}

.application-print-template .el-input {
  display: inline-flex;
  width: 300px;
}

.application-print-template p {
  margin: 0pt
}

.application-print-template table {
  margin-top: 0pt;
  margin-bottom: 0pt
}

.application-print-template .Heading7 {
  text-indent: 27pt;
  text-align: justify;
  page-break-inside: auto;
  page-break-after: avoid;
  font-family: 'Times New Roman';
  font-size: 14pt;
  font-weight: normal;
  font-style: normal;
  color: #000000
}

.application-print-template .BalloonText {
  font-family: Tahoma;
  font-size: 8pt
}

.application-print-template .BodyText {
  margin-bottom: 7pt;
  line-height: 115%;
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .BodyTextIndent {
  text-indent: 27pt;
  text-align: justify;
  font-family: 'Times New Roman';
  font-size: 14pt
}

.application-print-template .Caption {
  margin-top: 6pt;
  margin-bottom: 6pt;
  font-family: 'Times New Roman';
  font-size: 12pt;
  font-style: italic
}

.application-print-template .Footer {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .FrameContents {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .Header {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .HeaderandFooter {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .Heading {
  margin-top: 12pt;
  margin-bottom: 6pt;
  page-break-after: avoid;
  font-family: 'Liberation Sans';
  font-size: 14pt
}

.application-print-template .Index {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .List {
  margin-bottom: 7pt;
  line-height: 115%;
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .ListParagraph {
  margin-left: 36pt;
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .NormalWeb {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .float-left {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template .mb-0 {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template span.BalloonTextChar {
  font-family: Tahoma;
  font-size: 8pt
}

.application-print-template span.BodyTextIndentChar {
  font-family: 'Times New Roman';
  font-size: 14pt
}

.application-print-template span.FooterChar {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template span.HeaderChar {
  font-family: 'Times New Roman';
  font-size: 12pt
}

.application-print-template span.Heading7Char {
  font-family: 'Times New Roman';
  font-size: 14pt
}

.application-print-template span.PlaceholderText {
  color: #808080
}

@media (max-width: 900px) {
  .application-print-template img {
    max-width: 100%;
    height: auto;
  }

  .application-print-template .table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .application-print-template table {
    width: 100%;
    border-collapse: collapse;
  }

  .application-print-template td, th {
    padding: 8px;
    text-align: left;
    border: 1px solid #ddd;
  }
}
</style>